import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const LOCATION_DETAILS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('LOCATION_DETAILS');
export const LOCATION_DETAILS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	LOCATION_DETAILS_CRUD_ACTION_CONSTANTS
);
